import React from "react";
import "./Subtotal.css";
import CurrencyFormat from "react-currency-format";
import { useStateValue } from "./StateProvider";

function Subtotal() {
  const [state, dispatch] = useStateValue();

  console.log(state.basket);
  return (
    <div className="subtotal">
      <CurrencyFormat
        value={state.basket.reduce(
          (total, args) => total + parseFloat(args?.price.replace(/,/g, "")),
          0
        )}
        displayType={"text"}
        thousandSeparator={true}
        thousandSpacing={"2s"}
        decimalScale={2}
        prefix={"₹"}
        renderText={(value) => (
          <div>
            <p>
              SubTotal ({state.basket?.length} items) :<strong>{value}</strong>
            </p>
            <small className="subtotal_gift">
              <input type="checkbox"></input>
              This order conatins a gift
            </small>
          </div>
        )}
      />
      <button>Proceed To Checkout</button>
    </div>
  );
}

export default Subtotal;
